import { Component, OnInit, Input, Optional, ComponentFactoryResolver, ViewContainerRef, TemplateRef, ViewChild, SimpleChange } from '@angular/core';
import { AbstractControl, FormGroupDirective } from '@angular/forms';
import { map, switchMap, filter } from 'rxjs/operators';
import { of, merge, Observable, BehaviorSubject, combineLatest, forkJoin } from 'rxjs';
import { MmTranslateService } from '../../i18n/translate.service';

import { mmFormConstants } from '../form-constants';
import { NzFormControlComponent } from 'ng-zorro-antd/form';
import { formatStr } from 'mm-web-core/common';

@Component({
  selector: 'mm-required-message',
  templateUrl: './required-message.component.html',
  styleUrls: ['./required-message.component.scss']
})
export class MmRequiredMessageComponent implements OnInit {

  constructor(
    private translateService: MmTranslateService,
    private formGroup: FormGroupDirective,
    private resover: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    @Optional() public fc: NzFormControlComponent) {

  }


  asTemplate: boolean = false;
  message$: Observable<string>;

  @ViewChild(TemplateRef)
  template: TemplateRef<any>
  ngOnInit(): void {



    const root = this.formGroup.control.root;
    const group = this.formGroup.control;


    this.message$ = combineLatest(
      this.name$.pipe(filter(f => f != undefined)),
      this.labelName$.pipe(filter(f => f != undefined))
    ).pipe(
      map(([name, labelName]) => { return { name, labelName } }),
      switchMap(ctx => merge(
        of(undefined),
        root.valueChanges,
        group.valueChanges).pipe(map(() => ctx))),
      switchMap(ctx => {
        const control = group.controls[ctx.name];
        if (!control || control.valid) return of(undefined);
        var errors = control.errors;
        for (const e in errors) {
          switch (e) {
            case "required": {
              return this.requiredMessage(errors[e], ctx.labelName);
            }
            case "minlength": {
              return this.minlengthMessage(errors[e], ctx.labelName);
            }
          }
          // if (e === "required") {
          //   return this.translateService.format(this.resovleKey("RequiredFormat"), ctx.labelName);
          // }


          // var lang = /^required_(?<lang>.*)$/.exec(e).groups["lang"];
          // if (lang) {
          //   return this.translateService.format(this.resovleKey("I18nRequiredFormat"), this.resovleKey(lang), ctx.labelName);
          // }

          // if (e === "minlength") {

          // }
        }
        return of(undefined);
      })
    )




    if (this.fc) {
      this.message$.subscribe(msg => {

        const nzErrorTip = this.fc.nzErrorTip;
        this.fc.nzErrorTip = msg;
        this.fc.ngOnChanges({ nzErrorTip: new SimpleChange(nzErrorTip, this.fc.nzErrorTip, false) })
      })

      return;
    }
  }

  requiredMessage(val: any, labelName: string) {
    if (typeof val !== "object") {
      val = {}
    }

    for (const lang of this.translateService.supportedLangs) {
      if (val.lang == lang) {
        return this.translateService.format(this.resovleKey("I18nRequiredFormat"), this.resovleKey(lang), labelName);
      }
    }


  }
   minlengthMessage(val: any, labelName: string) {
    if (typeof val !== "object") {
      val = {}
    }


    if (val.length === undefined && !val.lang) {
      return this.translateService.get(this.resovleKey("Minlength")).pipe(
        map(str => {
          return formatStr(str, labelName)
        })
      )
    }
    else if (val.length === undefined && val.lang) {
      forkJoin(this.translateService.get("Minlength1"), this.translateService.get(this.resovleKey(val.lang))).pipe(
        map(([str, lang]) => {
          return formatStr(str, lang, labelName, val.length)
        })
      )
    }
    else if (val.length !== undefined && !val.lang) {
      return this.translateService.get(this.resovleKey("Minlength2")).pipe(
        map(str => {
          return formatStr(str, val.length)
        })
      )

    }
    else {
      return forkJoin(this.translateService.get("Minlength3"), this.translateService.get(this.resovleKey(val.lang))).pipe(
        map(([str, lang]) => {
          return formatStr(str, lang, labelName, val.length)
        })
      )
    }

  }

  name$ = new BehaviorSubject<string>(undefined);
  @Input()
  set name(_: string) {
    this.name$.next(_);
  }

  labelName$ = new BehaviorSubject<string>(undefined);
  @Input()
  set labelName(_: string) {
    this.labelName$.next(_);

  }

  resovleKey(key: string) {
    return `${mmFormConstants.translationGroup}.${key}`

  }



}
